<template>
  <div class="MyAttend" :style="style">
    <pull-to
        :top-load-method="refresh"
        @top-state-change="topStateChange"
        :bottom-load-method="loadmore"
        @bottom-state-change="bottomStateChange"
        :top-block-height="10"
        :bottom-block-height="10"
        style="font-size: 14px;color: #aaa;"
    >
      <trend-content :allTrend="allTrend" :refreshUrl="refreshData"></trend-content>
      <div v-show="loading"><img src="@/assets/img/loading.gif" style="margin: 30px auto;"></div>
      <div v-show="nomore" style="margin: 0 auto 20px;text-align: center;color: #aaa;font-size: 14px;">{{$t("没有更多了")}}</div>
      <div v-show="nodata"  style="margin: 80px 70px; width: 40%;">
        <img src="@/assets/img/nodata.png">
        <span style="color: #aaa;margin-left: 70px;font-size: 14px;" v-html="$t('暂无数据')"></span>
      </div>
    </pull-to>
  </div>
</template>

<script>
import PullTo from 'vue-pull-to'
import {getMoment} from "../../api/trend";

export default {
  name: "MyAttend",
  components: {
    PullTo
  },
  data() {
    return {
      alllist: false,
      limit_begin: 0,
      limit_num: 20,
      type: 3,
      current_num: 20,
      allTrend: [],
      nodata: false,
      nomore: false,
      loading: false,
      userInfo: this.$store.state.userInfo,
      style:{},
      refreshData:{
        limit_begin: 0,
        limit_num: 20,
        type: 3
      },
    }
  },
  created() {
    this.currentHeight()
  },
  activated() {
    this.limit_begin = 0
    this.getMyAttend()
  },
  methods: {
    /**
     * 获取我关注的列表
     */
    getMyAttend() {
      let post_data = {
        limit_begin: this.limit_begin,
        limit_num: this.limit_num,
        type: this.type,
        user_id: this.$store.state.userInfo.id
      }

      getMoment(post_data).then(res => {
        if (res.data.list.length == 0) {
          if(this.limit_begin==0){
            this.alllist=false
            this.allTrend = res.data.list
            this.nodata = true;
            this.nomore=false
          }else {
            this.nodata = false;
            this.nomore=true
          }
        } else {
          this.alllist = true;
          this.allTrend = res.data.list
          this.limit_begin = this.limit_begin + res.data.count
          this.nodata = false;
          this.nomore=false
        }
      })
    },
    refresh(loaded) {
      this.limit_begin = 0
      getMoment({
        limit_begin: this.limit_begin,
        limit_num: 20,
        type: this.type
      })
          .then((res) => {
            this.allTrend = res.data.list
            this.limit_begin = res.data.count
            loaded('done')
          })
    },
    topStateChange(state) {
      if (state === 'pull' || state === 'trigger') {
        this.iconLink = '#icon-arrow-bottom';
      } else if (state === 'loading') {
        this.iconLink = '#icon-loading';
      } else if (state === 'loaded-done') {
        this.iconLink = '#icon-finish';
      }
    },
    loadmore(loaded) {
      getMoment({
        limit_begin: this.limit_begin,
        limit_num: this.limit_num,
        type: this.type
      }).then(res => {
        if (res.data && res.data.count == 0) {
          if(this.limit_begin==0){
            this.nomore = false
          }else {
            this.nomore = true
          }
        } else {
          this.nomore = false
          this.allTrend = this.allTrend.concat(res.data.list);
          this.limit_begin = this.limit_begin + res.data.count
        }
        loaded('done');
      })
    },
    bottomStateChange(state) {
      if (state === 'pull' || state === 'trigger') {
        this.iconLink = '#icon-arrow-bottom';
      } else if (state === 'loading') {
        this.iconLink = '#icon-loading';
      } else if (state === 'loaded-done') {
        this.iconLink = '#icon-finish';
      }
    },
    currentHeight(){
      this.style.height = window.innerHeight-150 + 'px'
    }
  }
}
</script>

<style scoped>
.msgList ul li {
  border-bottom: 1px solid #e6e6e6;
  padding: .4rem 0;
}

.msgList .avatar {
  overflow: hidden;
  height: 4rem;
  padding: .0rem 0 0;
  color: #000;
}

.msgList .avatar img {
  border-radius: 50%;
  width: .8rem;
  height: .8rem;
  float: left;
}

.msgList .avatar .detail {
  color: #999;
  font-size: .25rem;
  font-size: 10px
}

.msgList .op {
  margin: 16px auto 0;
}

.msgList .op a {
  padding-left: .4rem;
  color: #999;
  height: .35rem;
  margin-right: 4%
}

.msgList .op .btn_share {
  background: url(../../assets/img/ico1.png) no-repeat 0 center;
  background-size: .35rem;
}

.msgList .op .btn_chat {
  background: url(../../assets/img/ico2.png) no-repeat 0 center;
  background-size: .35rem;
}

.msgList .op .btn_like {
  background: url(../../assets/img/ico3.png) no-repeat 0 center;
  background-size: .35rem;
}

.msgList .op .btn_likeon {
  background: url(../../assets/img/ico3_on.png) no-repeat 0 center;
  background-size: .35rem;
}

.msgList .newsbox a.more {
  padding: .15rem 0 .2rem;
  display: block;
  color: #2eccfa;
}

.msgList .newsbox p {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 30;
  -webkit-box-orient: vertical;
  word-break: break-all;
}

.newsbox {
  font-size: 16px;
  color: #000;
}

.dongtai_twoimg {
  height: 120px;
  width: 32%;
  float: left;
  margin: 0 1% 3px 0;
  overflow: hidden;
  vertical-align: middle;
  position: relative;
}

.two_img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.clear {
  zoom: 1;
}

.clear {
  clear: both;
}

.clear:after {
  display: block;
  content: "";
  clear: both;
  height: 0;
  overflow: hidden;
}

.comment {
  background: #fbfbfb;
  padding: 0 10px;
  margin-top: 10px;
}

.comment .look_all_comment {
  padding: 6px 0 10px;
  font-size: 12px;
  line-height: 16px;
  color: #237acf;
}

.comment .comment_cell {
  padding: 6px 0 0 0;
  color: #333;
  font-size: 12px;
  line-height: 16px;
}

.comment .comment_cell .user_nickname {
  color: #237acf;
}

.op .caozuo {
  width: 24.9%;
  text-align: left;
  display: inline-block;
  color: #666;
  font-size: 14px;
}

.op .caozuo img {
  width: 20px;
  display: inline;
  vertical-align: middle;
  margin: 0 5px 0 0;
}

.MyAttend {
  background: #ffffff;
  margin-top: 100px;
  height: 900px;
}

.allList {
  background: #fff;
  padding: 15px 20px;
  font-family: PingFang;
  margin-bottom: 520px;
}
</style>
